module.exports = __webpack_public_path__ + "files/71ee175bbf6e77eea9e8ead61d2f1d10.png";